<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
        <a-row :gutter="12">
           <a-col :md="6" :sm="8">
            <a-form-item label="Assignment Config">
            <a-select v-model="configsId" placeholder="SelectAssignment Config" style="width: 100%" @change="handConfigChange">
                <a-select-option v-for="item in configs" :value="item.id" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
          <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="addData">Add</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      
    <a-table :columns="columns" :dataSource="tableData" :loading="loading" :pagination="false" rowKey="id" bordered>
      <template slot="normalConfigId" slot-scope="text">
        {{ renderDictText2(normalConfigIds, text) || text }}
      </template>
      <template slot="ruleName" slot-scope="text">
        {{ renderDictText(collectionRuleConfigRuleNames, text) || text }}
      </template>
      <template slot="status" slot-scope="text">
        {{ renderDictText(collectionconfigstatus, text) || text }}
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">Edit Configuration</a>
        <a-divider type="vertical" />
        <a @click="handleEditFormula(record)">Edit Formula</a>
        <a-divider type="vertical" />
        <a @click="handleEditInputFormula(record)">Enter Formula</a>
      </template>
    </a-table>
<!-- Edit config -->
    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      :confirmLoading="saving"
      @ok="handleModalOk"
      @cancel="handleModalCancel"
    >
      <a-form ref="ruleForm" :form="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="Collection Stage" prop="normalConfigId">
          <a-select v-model="formModel.normalConfigId" placeholder="Select collection stage">
            <a-select-option v-for="item in normalConfigIds" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Level" prop="ruleName">
          <a-select v-model="formModel.ruleName" placeholder="Select level">
            <a-select-option
              v-for="item in collectionRuleConfigRuleNames"
              :key="item.itemValue"
              :value="item.itemValue"
            >
              {{ item.itemText }}
            </a-select-option>
                </a-select>
        </a-form-item>
        <a-form-item label="Rule Description" prop="remark">
          <a-textarea col='3' v-model="formModel.remark"/>
        </a-form-item>
        <a-form-item label="Claim Limit" prop="lowerLimit">
          <a-input-number
            v-model="formModel.lowerLimit"
            :min="5"
            :max="200"
            style="width: 100%"
            placeholder="Enter sort 5-200"
          />
        </a-form-item>
        <a-form-item label="Assign Limit" prop="biggerLimit">
          <a-input-number
            v-model="formModel.biggerLimit"
            :min="5"
            :max="200"
            style="width: 100%"
            placeholder="Enter sort 5-200"
          />
        </a-form-item>
        <a-form-item label="Is Active" prop="status">
          <a-select v-model="formModel.status" placeholder="Select status">
            <a-select-option v-for="item in collectionconfigstatus" :key="item.itemValue" :value="item.itemValue">
              {{ item.itemText }}
            </a-select-option>
                </a-select>
        </a-form-item>
        <a-form-item label="Sort" prop="index">
                <a-input-number 
            v-model="formModel.index"
            :min="1"
            :max="10"
            style="width: 100%"
            placeholder="Enter sort 1-10"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- Edit formula -->
    <CheckJexl
      :visible.sync="modalVisible2"
      :record="currentEditRecord"
      :collectionfeatures="collectionfeatures"
      @ok="handleJexlOk"
      @cancel="handleJexlCancel"
    />
    
    <!-- Input formula -->
    <InputJexl
      :visible.sync="modalVisible3"
      :record="currentEditRecord"
      :collectionfeatures="collectionfeatures"
      @ok="handleInputJexlOk"
      @cancel="handleInputJexlCancel"
    />
  </div>
</template>

<script>
import { getPageFirst, saveOrUpdateSecond, getPageSecond } from '@/webpublicapi/collection'
import { getDictList2 } from '@/webpublicapi/dict'
import { getProductConfig } from '@/webpublicapi/operation'
import CheckJexl from './modules/jexl1.vue'
import InputJexl from './modules/jexl2.vue'
export default {
  name: 'CollectionRule',
  components: {
    CheckJexl,
    InputJexl
  },
  data() {
    return {
      modalVisible2: false,
      modalVisible3: false,
      currentEditRecord: null, // Currently editing rule record
      configs: [],
      collectionconfigstatus: [], // Whether dictionary is valid
      collectionRuleConfigRuleNames: [], // Rule name
      normalConfigIds: [], //Collection stage
      configsId: '',
      tableData: [],
      loading: false,
      modalVisible: false,
      saving: false,
      isEdit: false,
      formModel: {
        normalConfigId: '',
        id: undefined,
        collectionConfigId: undefined,
        ruleName: '',
        lowerLimit: '',
        biggerLimit: '',
        status: '',
        remark: '',
        index: 1,
      },
      collectionfeatures:[],
      formRules: {
        ruleName: [{ required: true, message: 'Please select level (A-F)', trigger: 'change' }],
        lowerLimit: [{ required: true, message: 'Please enter claim limit', trigger: 'blur' }],
        biggerLimit: [{ required: true, message: 'Please enter assign limit', trigger: 'blur' }],
        status: [{ required: true, message: 'Please select status', trigger: 'change' }],
        index: [{ required: true, message: 'Please enter sort', trigger: 'blur' }],
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 17 },
      columns: [
        {
          title: 'Collection Stage',
          dataIndex: 'normalConfigId',
          scopedSlots: { customRender: 'normalConfigId' },
          align: 'center',
        },
        {
          title: 'Level (A-F)',
          dataIndex: 'ruleName',
          scopedSlots: { customRender: 'ruleName' },
          align: 'center',
        },
        {
          title: 'Claim Limit',
          dataIndex: 'lowerLimit',
          align: 'center',
        },
        {
          title: 'Assign Limit',
          dataIndex: 'biggerLimit',
          align: 'center',
        },
        {
          title: 'Sort',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: 'Status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
        },
        {
          title: 'Description',
          dataIndex: 'remark',
          align: 'center',
        },
        {
          title: 'Configuration',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 320,
        },
      ],
    }
  },
  computed: {
    modalTitle() {
      return this.isEdit ? 'Edit Rule' : 'Add Rule'
    },
  },
  created() {
    getPageFirst({ pageNum: 1, pageSize: 10000 }).then((res) => {
      this.configs = res.data.list || []
    })
    getDictList2({
      code: [
        'collectionConfigStatus',
        'collectionRuleConfigLowerLimit',
        'collectionRuleConfigBiggerLimit',
        'collectionfeatures',
        'grouplevel'
      ],
    }).then((res) => {
      this.collectionconfigstatus = res.data.collectionconfigstatus || []
      this.collectionRuleConfigRuleNames = res.data.grouplevel || []
      this.collectionfeatures = res.data.collectionfeatures || []
    })
    getProductConfig().then((res) => {
      this.normalConfigIds = res.data || []
    })
  },
  methods: {
    // ==================== Data loading related ====================
    handConfigChange() {
      this.loadData()
    },
    loadData() {
      if (!this.configsId) {
        this.tableData = []
        return
      }
      this.loading = true
      getPageSecond({ pageNum: 1, pageSize: 50, collectionConfigId: this.configsId })
        .then((res) => {
          this.tableData = res.data.list || []
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message || 'Query failed')
        })
    },

    // ==================== Form processing related ====================
    addData() {
      if (!this.configsId) {
        this.$message.error('Please select assignment config')
        return
      }
      this.isEdit = false
      this.resetForm()
      this.modalVisible = true
    },
    handleEdit(record) {
      this.isEdit = true
      this.formModel = {
        ...record,
        ruleName: this.toStr(record.ruleName),
        // lowerLimit: this.toStr(record.lowerLimit),
        // biggerLimit: this.toStr(record.biggerLimit),
        remark: this.toStr(record.remark),
        status: this.toStr(record.status),
      }
      this.modalVisible = true
    },
    resetForm() {
      this.formModel = {
        id: '',
        collectionConfigId: this.configsId,
        ruleName: '',
        lowerLimit: '5',
        biggerLimit: '5',
        remark: '',
        status: '',
        index: '1',
      }
    },
    handleModalOk() {
      const formRef = this.$refs.ruleForm
      if (formRef && typeof formRef.validate === 'function') {
        formRef.validate((valid) => {
          if (!valid) {
            return
          }
          this.submitForm()
        })
      } else {
        // Fallback validation (some scenarios ref Only return DOM)
        const valid = this.manualValidate()
        if (valid) {
          this.submitForm()
        }
      }
    },
    handleModalCancel() {
      this.modalVisible = false
    },
    manualValidate() {
      const requiredFields = [
        { key: 'ruleName', message: 'Please select level (A-F)' },
        { key: 'lowerLimit', message: 'Please enter claim limit' },
        { key: 'biggerLimit', message: 'Please enter assign limit' },
        { key: 'status', message: 'Please select status' },
        { key: 'index', message: 'Please enter sort' },
      ]
      for (const field of requiredFields) {
        if (
          this.formModel[field.key] === '' ||
          this.formModel[field.key] === undefined ||
          this.formModel[field.key] === null
        ) {
          this.$message.error(field.message)
          return false
        }
      }
      return true
    },
    submitForm() {
      this.saving = true
      saveOrUpdateSecond(this.formModel)
        .then((res) => {
          if (res.code === 1000) {
            this.$message.success('Saved successfully')
            this.modalVisible = false
            this.loadData()
          } else {
            this.$message.error(res.msg || 'Save failed')
          }
          this.saving = false
        })
        .catch((e) => {
          this.saving = false
          this.$message.error(e.message || 'Save failed')
        })
    },

    // ==================== Utility methods ====================
    toStr(value) {
      return value === undefined || value === null ? '' : value + ''
    },
    normalizeRecord(record = {}) {
      return {
        ...record,
        id: this.toStr(record.id),
        collectionConfigId: this.toStr(record.collectionConfigId),
        ruleName: this.toStr(record.ruleName),
        lowerLimit: this.toStr(record.lowerLimit),
        biggerLimit: this.toStr(record.biggerLimit),
        status: this.toStr(record.status),
        index: this.toStr(record.index),
        normalConfigId: this.toStr(record.normalConfigId)
      }
    },
    renderDictText(list, value) {
      if (!Array.isArray(list)) return ''
      const target = list.find((item) => item.itemValue == value)
      return target ? target.itemText : ''
    },
    renderDictText2(list, value) {
      if (!Array.isArray(list)) return ''
      const target = list.find((item) => item.id == value)
      return target ? target.name : ''
    },

    // ==================== Formula editor - Open/Close ====================
    handleEditFormula(record) {
      this.currentEditRecord = record
      this.modalVisible2 = true
    },
    handleEditInputFormula(record) {
      this.currentEditRecord = record
      this.modalVisible3 = true
    },
    handleJexlOk(payload) {
      this.modalVisible2 = false
      this.loadData()
    },
    handleJexlCancel() {
      this.modalVisible2 = false
      this.currentEditRecord = null
    },
    handleInputJexlOk(payload) {
      this.modalVisible3 = false
      this.loadData()
    },
    handleInputJexlCancel() {
      this.modalVisible3 = false
      this.currentEditRecord = null
    },
  },
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
}

.table-page-search-submitButtons {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.actions-bar {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}

.table-operations {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0;
}

.modal-form-footer {
  display: flex;
  justify-content: flex-end;
}

</style>
